import dataType from '../dataType';

const lse = {
    name: 'LSE',
    type: dataType.string
};

export default lse;
